
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export const ExternalAuthenticationBasicInfoComponent = ({ chosenAuthentications, handleInnerFormChange }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Enabled"
            name="IsEnabled"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'AzureActiveDirectory.IsEnabled',
                chosenAuthentications?.AzureActiveDirectory
              )
            }}
            type="checkbox"
            value={chosenAuthentications?.AzureActiveDirectory?.IsEnabled}
          />
          {chosenAuthentications?.AzureActiveDirectory?.IsEnabled? <><InputContainer
            label="Client ID"
            name="Client_Id"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'AzureActiveDirectory.Client_Id',
                chosenAuthentications?.AzureActiveDirectory
              )
            }}
            type="text"
            value={chosenAuthentications?.AzureActiveDirectory?.Client_Id}
          />
          <InputContainer
            label="Client Secret"
            name="Client_Secret"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'AzureActiveDirectory.Client_Secret',
                chosenAuthentications?.AzureActiveDirectory
              )
            }}
            type="text"
            value={chosenAuthentications?.AzureActiveDirectory?.Client_Secret}
          /></>: <></>}
        </div>
      }
      expandedPanel="AzureActiveDirectory Info"
      headerTitle="AzureActiveDirectory Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Enabled"
            name="IsEnabled"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'Google.IsEnabled',
                chosenAuthentications?.Google
              )
            }}            
            type="checkbox"
            value={chosenAuthentications?.Google?.IsEnabled}
          />
          {chosenAuthentications?.Google?.IsEnabled? <><InputContainer
            label="Client ID"
            name="Client_Id"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Google.Client_Id',
                chosenAuthentications?.Google
              )
            }}
            type="text"
            value={chosenAuthentications?.Google?.Client_Id}
          />
          <InputContainer
            label="Client Secret"
            name="Client_Secret"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Google.Client_Secret',
                chosenAuthentications?.Google
              )
            }}
            type="text"
            value={chosenAuthentications?.Google?.Client_Secret}
          /></>:<></>}
        </div>
      }
      expandedPanel="Google Info"
      headerTitle="Google Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Enabled"
            name="IsEnabled"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'FaceBook.IsEnabled',
                chosenAuthentications?.FaceBook
              )
            }}
            type="checkbox"
            value={chosenAuthentications?.FaceBook?.IsEnabled}
          />
          {chosenAuthentications?.FaceBook?.IsEnabled?<><InputContainer
            label="Client ID"
            name="Client_Id"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'FaceBook.Client_Id',
                chosenAuthentications?.FaceBook
              )
            }}
            type="text"
            value={chosenAuthentications?.FaceBook?.Client_Id}
          />
          <InputContainer
            label="Client Secret"
            name="Client_Secret"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'FaceBook.Client_Secret',
                chosenAuthentications?.FaceBook
              )
            }}
            type="text"
            value={chosenAuthentications?.FaceBook?.Client_Secret}
          /></>:<></>}

        </div>
      }
      expandedPanel="FaceBook Info"
      headerTitle="FaceBook Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Enabled"
            name="IsEnabled"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'Twitter.IsEnabled',
                chosenAuthentications?.Twitter
              )
            }}
            type="checkbox"
            value={chosenAuthentications?.Twitter?.IsEnabled}
          />
          {chosenAuthentications?.Twitter?.IsEnabled?<><InputContainer
            label="Client ID"
            name="Client_Id"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Twitter.Client_Id',
                chosenAuthentications?.Twitter
              )
            }}
            type="text"
            value={chosenAuthentications?.Twitter?.Client_Id}
          />
          <InputContainer
            label="Client Secret"
            name="Client_Secret"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Twitter.Client_Secret',
                chosenAuthentications?.Twitter
              )
            }}
            type="text"
            value={chosenAuthentications?.Twitter?.Client_Secret}
          /></>:<></>}
        </div>
      }
      expandedPanel="Twitter Info"
      headerTitle="Twitter Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Enabled"
            name="IsEnabled"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'Linkedin.IsEnabled',
                chosenAuthentications?.Linkedin
              )
            }}
            type="checkbox"
            value={chosenAuthentications?.Linkedin?.IsEnabled}
          />
          {chosenAuthentications?.Linkedin?.IsEnabled?<><InputContainer
            label="Client ID"
            name="Client_Id"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Linkedin.Client_Id',
                chosenAuthentications?.Linkedin
              )
            }}
            type="text"
            value={chosenAuthentications?.Linkedin?.Client_Id}
          />
          <InputContainer
            label="Client Secret"
            name="Client_Secret"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Linkedin.Client_Secret',
                chosenAuthentications?.Linkedin
              )
            }}
            type="text"
            value={chosenAuthentications?.Linkedin?.Client_Secret}
          /></>:<></>}
        </div>
      }
      expandedPanel="Linkedin Info"
      headerTitle="Linkedin Info"
    />
  </>
)
export default ExternalAuthenticationBasicInfoComponent;
